// extracted by css-extract-rspack-plugin
export default {"Box":"CodeViewError-module__Box__hQizCb5"};